export default __webpack_public_path__ + "static/media/Logo-IQVIA-white.c04b00a6.svg";